module.exports = __webpack_public_path__ + "static/img/Master Guardian I.486f3dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/csgo/ranks/Master Guardian I.png
// module id = 05d2
// module chunks = 35